import { DEALER_DELIVERY, HOME_DELIVERY } from './constants';
export const separateShippingMethods = (shippingMethods) => {
    return shippingMethods.reduce((acc, item) => {
        if (item.name.toLowerCase().includes(HOME_DELIVERY)) {
            acc.homeMethod = item;
        }
        if (item.name.toLowerCase().includes(DEALER_DELIVERY)) {
            acc.dealerMethod = item;
        }
        return acc;
    }, {
        homeMethod: null,
        dealerMethod: null,
    });
};
export const getShippingLabel = ({ shippingMethods, freeShippingAboveLabel, freeShippingLabel, totalPriceValue, }) => {
    const { homeMethod, dealerMethod } = separateShippingMethods(shippingMethods);
    if (dealerMethod && homeMethod) {
        const homeFreeAboveAmount = homeMethod?.shippingRates?.freeAbove?.amount;
        const homeShippingRatesPriceAmount = homeMethod.shippingRates.price.amount;
        const dealerShippingRatesPriceAmount = dealerMethod.shippingRates.price.amount;
        if ((homeFreeAboveAmount && totalPriceValue >= homeFreeAboveAmount) ||
            (homeShippingRatesPriceAmount === 0 && dealerShippingRatesPriceAmount === 0)) {
            return freeShippingLabel;
        }
        if (((homeFreeAboveAmount && totalPriceValue < homeFreeAboveAmount) || !homeFreeAboveAmount) &&
            dealerShippingRatesPriceAmount === 0) {
            return freeShippingAboveLabel;
        }
    }
    return '';
};
